import type { OtherCostCalculationTypeEnum, WorkOrderActKc2Data, WorkOrderOtherPriceData } from 'gql/graphql';
import { ContractOtherStatusEnum } from 'gql/graphql';

export const TABLE_GROUP_NAME: { [index: string]: string } = {
    CUSTOMER_LIMITS: 'Лимиты Заказчика',
    CHAPTER9: 'Прочие затраты 9 Главы',
    WORK_ORDER_TOTALS: 'Итоги НЗ',
    OTHERS: 'Прочие',
};

export const enum CalculationTypes {
    PERCENT = 'PERCENT',
    CALCULATION = 'CALCULATION',
}

const prepareSeasons = (item: WorkOrderOtherPriceData) => ({
    ...item?.seasonPrices?.reduce((acc: any, { planCost, completedCost, remainderCost, seasonId }) => {
        acc[`seasonValue_${seasonId}`] = planCost;
        acc[`seasonCompletedCost_${seasonId}`] = completedCost;
        acc[`seasonRemainderCost_${seasonId}`] = remainderCost;

        return acc;
    }, {}),
});

const prepareActs = (item: WorkOrderOtherPriceData) => ({
    ...item?.actKC2Prices?.reduce((acc: any, value) => {
        acc[`actKC2PlanCost_${value.actKC2Id}`] = value.planCost;
        acc[`actKC2PlanCostDeviation_${value.actKC2Id}`] = value.planCostDeviation;
        acc[`actKC2AcceptedCost_${value.actKC2Id}`] = value.acceptedCost;
        acc[`actKC2AcceptedCostDeviation_${value.actKC2Id}`] = value.acceptedCostDeviation;

        return acc;
    }, {}),
});

export const preparedOtherData = ({
    otherPrice: rawData,
    actsKC2,
}: {
    otherPrice: WorkOrderOtherPriceData;
    actsKC2: WorkOrderActKc2Data[];
}) => ({
    ...rawData,
    type: rawData.status === ContractOtherStatusEnum.NewRecord ? 'OTHERS_NEW' : 'OTHERS',
    ...prepareSeasons(rawData),
    ...prepareActs(rawData),
    actKC2Prices: rawData.actKC2Prices?.map((actKC2Prices: { actKC2Id: number }) => ({
        ...actKC2Prices,
        actKC2status: actsKC2.find((act: { id: number }) => act.id === actKC2Prices.actKC2Id)?.status,
    })),
});

export type rowsWithGroupTitle =
    | (WorkOrderOtherPriceData & { type: 'OTHERS_NEW' | 'OTHERS' })
    | {
          id: any;
          name: string;
          isGroupTitle: boolean;
          calculatingType?: OtherCostCalculationTypeEnum | null | undefined;
      };

export const getGroupedRows = (
    rawData: WorkOrderOtherPriceData[] | null | undefined,
    actsKC2: WorkOrderActKc2Data[],
): rowsWithGroupTitle[] => {
    if (!rawData) {
        return [];
    }

    const itemByGroup = rawData.reduce((acc: { [key: string]: rowsWithGroupTitle[] }, item) => {
        const groupName = item.chapter || item.section;

        if (!groupName) {
            return acc;
        }

        if (!acc[groupName]) {
            acc[groupName] = [
                {
                    id: groupName,
                    name: TABLE_GROUP_NAME[groupName],
                    isGroupTitle: true,
                },
            ];
        }

        const preparedItem = preparedOtherData({
            otherPrice: item,
            actsKC2,
        });

        acc[groupName].push(preparedItem);

        return acc;
    }, {});

    return Object.values(itemByGroup).reduce((acc, item) => acc.concat(item), []);
};

export const getOtherRowStyleRules = {
    groupHeader: ({ data }: any) => data?.isGroupTitle,
    excludedClass: ({ data }: any) => data?.isExcludedPrice,
};
